import type { Whoami } from './types';

export class User {
  private readonly whoami: Whoami;

  private constructor(whoami: Whoami) {
    this.whoami = whoami;
  }

  static fromWhoami(whoami: Whoami | undefined): User | undefined {
    return whoami ? new User(whoami) : undefined;
  }

  get email(): string | undefined {
    return this.whoami.logins?.find((login) => login.type === 'email')?.emailAddress;
  }

  isAuthorised(action: string, resourceId = 'account:*'): boolean {
    return (this.whoami.permissions ?? []).some(
      (permission) =>
        permission.actions.includes(action) &&
        (permission.resources.includes(resourceId) || permission.resources.includes('account:*'))
    );
  }
}
